import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.072 4.48a.6.6 0 0 0 0-.159v-.06a.6.6 0 0 0-.052-.12.3.3 0 0 0-.038-.06l-.075-.099-.151-.113L7.973.101a.75.75 0 0 0-.753 0L.437 3.869l-.068.053-.083.06a.3.3 0 0 0-.052.083.3.3 0 0 0-.06.075.5.5 0 0 0-.046.106.2.2 0 0 0 0 .075A.6.6 0 0 0 0 4.48v6.028a.75.75 0 0 0 .392.656l6.782 3.768a.6.6 0 0 0 .098.045h.076a.8.8 0 0 0 .377 0H7.8l.105-.045 6.783-3.768a.75.75 0 0 0 .384-.655zM7.536 7.396 2.306 4.48l2.08-1.146 5.147 2.94zm0-5.818 5.23 2.902-1.688.942-5.147-2.947zM1.507 5.761l5.276 2.954v4.28l-5.276-2.931zm6.783 7.234v-4.28l2.26-1.266v2.306L12.059 9V6.605l1.507-.837v4.296z"
    }, null, -1)
  ])))
}
export default { render: render }